import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { InputGroup, Button, CardBody, Card, Collapse, FormGroup, Label, Input, ButtonGroup } from 'reactstrap';
import moment from 'moment';

import AuthProvider from '../../AuthProvider';
import actions from '../problema/actions';
import Prompt from '../../components/Prompt';
import Confirm from '../../components/Confirm';

const opcoes = [
  ["Registrar Entregas", 'Confirmar Entregas?', ["agua-mineral"], "primary", "REGISTRAR_ENTREGA_AGUA_MINERAL"],
  ["Solicitar Água Mineral", 'Confirmar Solicitação?', ["morador"], "primary", "SOLICITAR_AGUA_MINERAL"],
//  ["Solicitar Limpeza Hall", 'Confirmar Solicitação?', ["morador"], "primary", "SOLICITAR_LIMPEZA_HALL"],
  ["Agendar Reserva", 'Registrar Agendamento', ["morador"], "secondary", "AGENDAR_RESERVA", ["Informe a data do evento:"]],
  ["Informar Mudança", 'Registrar Mudança', ["morador"], "secondary", "INFORMAR_MUDANCA", ["Informe a data da saída:"]],
  ["Alertar Veículo", 'Confirmar Alerta', ["morador", "zelador", "sindico", "conselheiro", "proprietario"], "secondary", "INFORMAR_PROBLEMA_VEICULO", ["Informe a placa do veículo:", { type: "text", min: null }, value => 6 < value.length, "Notifique o morador de alguma eventualidade no veículo. Exemplo: luz interna acesa, faróis ligados, vidros entreabertos, etc."]],
//  ["Relatar Cigarro Hall", 'Confirmar relato?', ["morador"], "warning", "RELATAR_CIGARRO"]
];

class PrincipaisSolicitacoes extends Component {
  input = {};

  constructor (props) {
    super(props);

    this.state = {
      promptUnidade: false,
      confirmText: "",
      fetching: {},
      open: {},
      data: {},
      input: opcoes.reduce((s, _v, i) => {
        s[i] = '';
        return s;
      }, {})
    };

    this.onConfirm = this.onConfirm.bind(this);
    this.onConfirm2 = this.onConfirm2.bind(this);
  }

  handleInput (i) {
    return e => {
      const { value } = e.target;

      this.setState(state => ({
        input: {
          ...state.input,
          [i]: value.toUpperCase().replace(/^\s+|\s+(?=\s$|\s)/g, "")
        }
      }));
    }
  }

  openCard (i) {
    this.toggleState('open', i);
  }

  clearInput (i) {
    this.setState(state => ({
      open: {
        ...state.open,
        [i]: !state.open[i]
      },
      input: {
        ...state.input,
        [i]: ''
      }
    }));
  }

  toggleState (state, value) {
    this.setState(data => ({
      [state]: {
        ...data[state],
        [value]: !data[state][value]
      }
    }));
  }

  registraRelatoSimplificado (tipo, data, dispatch) {
    this.toggleState('fetching', tipo);

    return this.props.actions.onExecutaAcaoSimplificada({ ...data, tipo })
    .then(value => {
      switch (tipo) {
        case "REGISTRAR_ENTREGA_AGUA_MINERAL":
          this.setState({confirmText: 'Entregas confirmadas: ' + value.result});
          break;
        default:
          this.setState({confirmText: 'Registro realizado com sucesso.'});

          let link = document.createElement("a");
          link.setAttribute("href", value.location);
          link.setAttribute("style", "display: none");
          //link.setAttribute("target", "_blank");
          document.body.appendChild(link);
          link.click();
          link.parentElement.removeChild(link);
          break;
      }
    }, error => {
      if (error instanceof Error) {
        switch (error.message) {
          case "VEICULO_NAO_CADASTRADO":
            this.setState({ promptUnidade: true, data: { ...data, tipo } });
            break;
          case "VALIDATION_REQUIRED":
            if ("id_empresa" === error.messages[0].params.name) {
              this.setState({confirmText: <div>Não foi definida marca padrão de água mineral.<br />Para definí-la, é necessário fazer ao menos 1 solicitação pelo menu Consumo.</div>});
            }
            break;
          default:
            console.log(error);
            this.setState({confirmText: 'Ocorreu um problema desconhecido.'});
            break;
        }
      } else {
        console.log(error);
        this.setState({confirmText: 'Ocorreu um problema desconhecido.'});
      }
    })
    .then(() => {
      this.toggleState('fetching', tipo);
    }, err => console.log(err));
  }

  getLabel (acao, valid) {
    if (this.state.fetching[acao[4]]) {
      return 'Aguarde...';
    }
    return valid?acao[1]:acao[0];
  }

  onConfirm (unidade) {
    this.props.actions.onExecutaAcaoSimplificada({ ...this.state.data, unidade })
    .then(() => {
      this.setState({ promptUnidade: false, data: {} });
    });
  }

  onConfirm2 () {
    this.setState({ confirmText: '' });
  }

  render () {
    let { dispatch } = this.props;

    const isValid = value => moment(value).isAfter();

    return (<div><InputGroup>
    <AuthProvider>
      {(_undefined, containsRole) => (
        opcoes
        .filter(v => containsRole(v[2]))
        .map((v, i) => {
          let valid = (!v[5] && this.state.open[i]) || (!!v[5] && (v[5][2]||isValid)(this.state.input[i]));

          return (
            <div key={i} className="btn-block">
              <form>
              <ButtonGroup className="btn-block">
                <Button type="submit" disabled={this.state.fetching[v[4]]} color={valid?"success":v[3]} size="lg" block onClick={(e) => {
                  e.preventDefault();
                  if (valid) {
                    this.registraRelatoSimplificado(v[4], (!v[5]?{}:{value:this.state.input[i]}), dispatch);
                  }
                  this.clearInput(i);
                }}>{this.getLabel(v, valid)}</Button>
                {valid && <Button color="danger" onClick={() => {
                  this.clearInput(i);
                }}><span className="fa fa-times" /></Button>}
              </ButtonGroup>
              {!!v[5] && <Collapse isOpen={this.state.open[i]}>
                <Card>
                  <CardBody>
                    <FormGroup>
                      <Label>{v[5][0]}</Label>
                      <Input required onChange={this.handleInput(i)} value={this.state.input[i]} valid={valid} type="date" min={moment().add(1, 'day').format('YYYY-MM-DD')} {...v[5][1]} />
                      {v[5][3]||null}
                    </FormGroup>
                  </CardBody>
                </Card>
              </Collapse>}
              </form>
            </div>
          );
        })
      )}
    </AuthProvider>
    </InputGroup>
    <Prompt headerText="Apartamento" isOpen={this.state.promptUnidade} valid={value => 2 < value.length} onConfirm={this.onConfirm}>Informe o número da vaga:</Prompt>
    <Confirm isOpen={!!this.state.confirmText} onConfirm={this.onConfirm2}>{this.state.confirmText}</Confirm>
    <br />
    </div>);
  }
}

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(null, mapDispatchToProps)(PrincipaisSolicitacoes);



// WEBPACK FOOTER //
// ./src/modules/inicio/PrincipaisSolicitacoes.js